import { Box, Text } from "@chakra-ui/react";
import CheckListStatusBadge from "../ChecklistItem/CheckListStatusBadge";
import RangeDate from "../ChecklistItem/RangeDate";

interface IBorrowerStatusDetailProps {
  status: string;
  startDate: string;
  dueDate: string;
  category: string;
}

const BorrowerStatusDetail = ({ status, startDate, dueDate, category }: IBorrowerStatusDetailProps) => {
  return (
    <Box border="1px solid #E0E0E0" borderRadius="8px" p="16px" mb="20px">
        <Box display="flex" flexDirection="row" gap="16px">
            <Box width="100%">
                <Text fontSize="14px" color="gray.600" mb="16px">Status</Text>
                <Text fontSize="14px" color="gray.600" mb="16px">
                <CheckListStatusBadge status={status} />
                </Text>
            </Box>
            {startDate && dueDate && (
                <Box width="100%">
                <Text fontSize="14px" color="gray.600" mb="16px">Date range</Text>
                <Text fontSize="14px" color="gray.600" mb="16px">
                    <RangeDate start_date={startDate} due_date={dueDate} />
                </Text>
                </Box>
            )}
            <Box width="100%">
                <Text fontSize="14px" color="gray.600" mb="16px">Category</Text>
                <Text fontSize="14px" color="gray.600" mb="16px">
                {category}
                </Text>
            </Box>
        </Box>
    </Box>
  );
};

export default BorrowerStatusDetail;
